import React from "react";

function Training() {
  return <div>Training</div>;
}

export default Training;
